import api from '../setup/axios';
import config from '../setup/config';

export default {
  /**
   * List available permissions
   * @returns { Array } List of permissions with name and descriptions
   */
  async getPermissions() {
    const path = `${config.microservices.chatApi}/permissions`;
    const { data } = await api.get(path);

    return data;
  },

  /**
   * List all assigned permissions to a role
   * @param { Number } roleId Role ID
   * @returns { Array } List of permissions IDs assigned to the role
   */
  async getRolePermissions(roleId) {
    const path = `${config.microservices.chatApi}/roles/${roleId}/permissions`;
    const { data } = await api.get(path);

    return data;
  },

  /**
   * Assigns a permission to a role
   * @param { Number } permissionId Permission ID
   * @param { Number } roleId Role ID
   * @returns null
   */
  async assignPermissionRole(permissionId, roleId) {
    const path = `${config.microservices.chatApi}/roles/${roleId}/permission/${permissionId}`;

    await api.post(path);
  },
  
  /**
   * Deletes a permission from a role
   * @param { Number } permissionId Permission ID
   * @param { Number } roleId Role ID
   * @returns 
   */
  async unassignPermissionRole(permissionId, roleId) {
    const path = `${config.microservices.chatApi}/roles/${roleId}/permission/${permissionId}`;

    await api.delete(path);
  }
}
